import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

import type { PostFilter } from '../../model/post-filter.model';

/**
 * The posts search + filter bar is owned by the perks wrapper -- its query and filters drive the
 * loadPosts call for the whole page -- but it renders inside the feed's left column so the right
 * column can sit level with it rather than starting below a full-width bar. This carries the bar's
 * state down to the column that draws it.
 */
export interface PostFilterBar {
  /** false while the bar is suppressed: the "Search" block setting, or an access-code visitor */
  visible?: boolean;
  hasActiveFilters?: boolean;
  /** the filter the feed was loaded with; every later page and reload has to carry it too */
  filter?: PostFilter;
  onSearch?: (query: string) => void;
  /** a tagId opens the modal with that tag preselected (post tag badges) */
  onOpenFilterModal?: (tagId?: string) => void;
}

export const PostFilterBarContext = createContext<PostFilterBar>({});

export const usePostFilterBar = () => useContext(PostFilterBarContext);
